import Link from 'gatsby-link';
import styled from 'styled-components';
import fn from '../../helpers/fn';

export default fn(__filename, styled(Link)`
  color: inherit;
  display: inline-block;
  line-height: initial;
  text-decoration: none;
  vertical-align: text-bottom;

  ${({ showUnderlineHover }) => showUnderlineHover && `
    &:hover {
      text-decoration: underline;
    }
  `}

  li & {
    text-decoration: none;
  }
`);



// WEBPACK FOOTER //
// ./src/components/links/Link.js